const React = require('react');
const ReactDOM = require('react-dom');
const Common = require('./common');

const AppDataContext = Common.contextType;

const Page = class Page extends Common {};

Page.AppDataContext = AppDataContext;

Page.renderToDom = function (id = 'app') {
    return function (CPage) {
        if (process.title === 'browser') {
            console.log('client render start');
            window.AppData = {};
            try {
                window.AppData = JSON.parse(document.getElementById('__state').innerHTML);
            } catch (e) {
                console.error('AppData 解析错误！');
            }
            const start = Date.now();
            ReactDOM.hydrate(
                React.createElement(
                    AppDataContext.Provider,
                    { value: window.AppData },
                    React.createElement(CPage, window.AppData),
                ),
                document.getElementById(id),
            );
            console.log('client render end ', Date.now() - start);
        }
    };
};

module.exports = Page;
